import { Component, inject, input, OnInit, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { animalInfo } from '../../../components/minerva-report/minerva-report.component';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { MinervaService } from '../../../services/minerva.service';

@Component({
  selector: 'app-minerva-report-table-version',
  standalone: true,
  imports: [
    MatTableModule,
    CommonModule,
  ],
  templateUrl: './minerva-report-table-version.component.html',
  styleUrl: './minerva-report-table-version.component.scss'
})
export class MinervaReportTableVersionComponent implements OnInit {
  handleReportData = output();
  handleCorporateName = output();
  corporateName = '';
  qualityChainId: any;
  displayedColumns: string[] = ['animalId', 'breed', 'sex', 'maturity', 'birth', 'earring', 'rating', 'inl'];
  size = 100000;
  length = 100000;
  activatedRoute = inject(ActivatedRoute);
  minervaService = inject(MinervaService);
  reportData: any;
  indirectAcquiredData: any;
  reportStatus: any;

  ngOnInit(): void {
    this.qualityChainId = this.activatedRoute.snapshot.paramMap.get('qualityChainId');
    this.reportStatus = this.activatedRoute.snapshot.paramMap.get('reportStatus');
    this.minervaService.getQualityChainById(this.qualityChainId).subscribe({
      next: (res: any) => {
        this.corporateName = res.provider.corporateName;
        this.indirectAcquiredData = res.outsourced.map((item: any) => {
          if (this.reportStatus === 'ENABLED' || this.reportStatus === 'POST_ANALYSIS_ENABLED') {
            if (item.analysis.status === 'ENABLED' || item.analysis.status === 'POST_ANALYSIS_ENABLED') {
              return {
                name: item.corporateName,
                status: item.analysis.status,
                gta: item.place.code,
                animalData: item.items.map((animal: any) => {
                  return {
                    animalId: animal.identifier.code ? animal.identifier.code : 'Não informado',
                    birth: animal.birthDate ? this.getDate(animal.birthDate) : 'Não informado',
                    rating: animal.identifier.type ? this.formatData(animal.identifier.type, 'rating') : 'Não informado',
                    earring: animal.identifier.date ? this.getDate(animal.identifier.date) : 'Não informado',
                    sex: animal.gender ? this.formatData(animal.gender, 'gender') : 'Não informado',
                    breed: animal.breed ? animal.breed : 'Não informado',
                    maturity: animal.category ? this.formatData({ birthDate: animal.birthDate, purchaseDate: animal.purchaseDate }, 'category') : 'Não informado',
                    inl: animal.inl ? animal.inl : 'Não informado'
                  };
                })
              };
            } else {
              return null
            }
          } else {
            return {
              name: item.corporateName,
              status: item.analysis.status,
              gta: item.place.code,
              animalData: item.items.map((animal: any) => {
                return {
                  animalId: animal.identifier.code ? animal.identifier.code : 'Não informado',
                  birth: animal.birthDate ? this.getDate(animal.birthDate) : 'Não informado',
                  rating: animal.identifier.type ? this.formatData(animal.identifier.type, 'rating') : 'Não informado',
                  earring: animal.identifier.date ? this.getDate(animal.identifier.date) : 'Não informado',
                  sex: animal.gender ? this.formatData(animal.gender, 'gender') : 'Não informado',
                  breed: animal.breed ? animal.breed : 'Não informado',
                  maturity: animal.category ? this.formatData({ birthDate: animal.birthDate, purchaseDate: animal.purchaseDate }, 'category') : 'Não informado',
                  inl: animal.inl ? animal.inl : 'Não informado'
                };
              })
            };
          }
        }).filter(Boolean);
        
        this.getReportData();
      },
      error: (err) => {
        console.error('Erro ao buscar dados da cadeia de qualidade:', err);
      },
      complete: () => {
      }
    });
  }

  getReportData(): void {
    this.reportData = this.indirectAcquiredData.flatMap((item: any) => {
      return item.animalData.map((animal: any) => {
        return {
          ...animal
        };
      });
    });
    this.handleReportDataClick(this.reportData);
    this.handleCorporateNameClick(this.corporateName);
  }

  formatDate(startDateStr: string, endDateStr: string): number {
    const [startDay, startMonth, startYear] = startDateStr.split('/').map(Number);
    const [endDay, endMonth, endYear] = endDateStr.split('/').map(Number);

    const startDate = new Date(startYear, startMonth - 1, startDay);
    const endDate = new Date(endYear, endMonth - 1, endDay);

    let months = (endYear - startYear) * 12 + (endMonth - startMonth);

    if (endDay < startDay) {
      months--;
    }

    return months;
  }

  formatData(data: any, dataName: string): string {
    let updatedString = '';
    if (dataName === 'category') {
      const birth = data?.birthDate ? new Date(data.birthDate) : null;
      const purchase = data?.purchaseDate ? (() => {
        const parts = String(data.purchaseDate).split('-').map(Number);
        if (parts.length >= 3) {
          return new Date(Date.UTC(parts[0], parts[1] - 1, parts[2]));
        }
        const d = new Date(data.purchaseDate);
        return isNaN(d.getTime()) ? null : d;
      })() : null;

      if (!birth || !purchase || isNaN(birth.getTime()) || isNaN(purchase.getTime())) {
        return 'Não informado';
      }

      const by = birth.getUTCFullYear();
      const bm = birth.getUTCMonth();
      const bd = birth.getUTCDate();

      const py = purchase.getUTCFullYear();
      const pm = purchase.getUTCMonth();
      const pd = purchase.getUTCDate();

      let months = (py - by) * 12 + (pm - bm);
      if (pd < bd) months--;

      updatedString = String(months >= 0 ? months : 0);
    } else if (dataName === 'rating') {
      switch (data) {
        case "IDC":
          updatedString = "IN";
          break;
        case "IDR":
          updatedString = "IN12";
          break;
      }
    } else if (dataName === 'gender') {
      {
        switch (data) {
          case "MALE":
            updatedString = "M";
            break;
          case "FEMALE":
            updatedString = "F";
            break;
        }
      }
    } else if (dataName === 'rating') {
      switch (data) {
        case "IDC":
          updatedString = "IN";
          break;
        case "IDR":
          updatedString = "IN12";
          break;
      }
    } else if (dataName === 'gender') {
      {
        switch (data) {
          case "MALE":
            updatedString = "M";
            break;
          case "FEMALE":
            updatedString = "F";
            break;
        }
      }
    }
    return updatedString;
  }

  getDate(date?: Date): string {
    const data = date ? new Date(date) : new Date();
    const dia = data.getUTCDate();
    const mes = data.getUTCMonth() + 1;
    const ano = data.getUTCFullYear();
    const dataFormatada = `${dia < 10 ? '0' + dia : dia}/${mes < 10 ? '0' + mes : mes}/${ano}`;
    return dataFormatada;
  }

  handleReportDataClick(element: any) {
    this.handleReportData.emit(element);
  }

  handleCorporateNameClick(element: any) {
    this.handleCorporateName.emit(element);
  }

}


